export default {
  on: {
    pageInit: function (e, page) {
      var app = this.$app;
      var $$ = this.$;
      var searchTimeout = null;
      var currentReq = null;
      function esc(s) {
        if (s === null || s === undefined)
          return '';
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      function showInitial() {
        $$('#searchInitialState').show();
        $$('#universalResults').hide();
        $$('#searchNoResults').hide();
      }
      function renderDoctorRow(d) {
        var dp = d.dp_url ? d.dp_url : 'static/img/default_doctor.svg';
        var partnerClass = d.isPartnerDoctor == 1 ? ' is-partner' : '';
        var verifiedChip = d.isPartnerDoctor == 1 ? '<a href="#" class="doctor-verified-chip partner-info-btn">' + '<i class="icon f7-icons if-not-md doctor-verified-chip-seal">checkmark_seal_fill</i>' + '<i class="icon material-icons md-only doctor-verified-chip-seal">verified</i>' + '<span class="doctor-verified-chip-text">mDOC Verified</span>' + '</a>' : '';
        var deptChip = d.dep_name ? '<span class="doctor-card-chip doctor-card-chip-dept">' + esc(d.dep_name) + '</span>' : '';
        var hospitalLine = d.hospital_name ? '<div class="doctor-card-hospital">' + '<div class="doctor-card-hospital-info">' + '<i class="icon f7-icons if-not-md">house_fill</i>' + '<i class="icon material-icons md-only">local_hospital</i>' + '<div><div class="doctor-card-hospital-name">' + esc(d.hospital_name) + '</div></div>' + '</div>' + '</div>' : '';
        var bookBtn = d.preLive == 0 ? '<button type="button" class="doctor-card-book doctor-card-book-disabled" disabled>Currently unavailable</button>' : '<a href="/booking/' + esc(d.id) + '/Normal/" class="doctor-card-book link">Book appointment</a>';
        return '<div class="doctor-card' + partnerClass + '">' + '<div class="doctor-card-top">' + '<div class="doctor-card-photo"><img src="' + esc(dp) + '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'"></div>' + '<div class="doctor-card-info">' + '<div class="doctor-card-name">Dr. <span class="doctorNameSearch">' + esc(d.name) + '</span></div>' + verifiedChip + '<div class="doctor-card-meta">' + deptChip + '</div>' + '</div>' + '<div class="doctor-card-fee"><div class="doctor-card-fee-label">Fee</div><div class="doctor-card-fee-amount">\u20B9' + esc(d.fee) + '</div></div>' + '</div>' + hospitalLine + '<div class="doctor-card-actions">' + bookBtn + '</div>' + '</div>';
      }
      function renderDepartmentRow(dept) {
        var img = dept.image_url ? dept.image_url : 'static/img/default_icon.svg';
        return '<a href="/doctors/' + esc(dept.id) + '/' + esc(dept.name) + '/" class="universal-result-item link">' + '<div class="universal-result-thumb"><img src="' + esc(img) + '" alt="" onerror="this.src=\'static/img/default_icon.svg\'"></div>' + '<div class="universal-result-body"><div class="universal-result-title">' + esc(dept.name) + '</div><div class="universal-result-sub">Speciality</div></div>' + '<i class="icon f7-icons if-not-md universal-result-arrow">chevron_right</i>' + '<i class="icon material-icons md-only universal-result-arrow">chevron_right</i>' + '</a>';
      }
      function renderHospitalRow(h) {
        var img = h.image_url ? h.image_url : 'static/img/default_hospital.svg';
        var sub = h.address ? esc(h.address) : 'Hospital';
        return '<a href="/hospital/' + esc(h.id) + '/' + esc(h.name) + '/" class="universal-result-item link">' + '<div class="universal-result-thumb"><img src="' + esc(img) + '" alt="" onerror="this.src=\'static/img/default_hospital.svg\'"></div>' + '<div class="universal-result-body"><div class="universal-result-title">' + esc(h.name) + '</div><div class="universal-result-sub">' + sub + '</div></div>' + '<i class="icon f7-icons if-not-md universal-result-arrow">chevron_right</i>' + '<i class="icon material-icons md-only universal-result-arrow">chevron_right</i>' + '</a>';
      }
      function renderTestRow(t) {
        var sub = t.lab_name ? esc(t.lab_name) : 'Lab Test';
        var price = t.price ? '<div class="universal-result-price">\u20B9' + esc(t.price) + '</div>' : '';
        return '<a href="/pathlab-tests/' + esc(t.lab_id) + '/" class="universal-result-item link">' + '<div class="universal-result-thumb universal-result-thumb-icon">' + '<i class="icon f7-icons if-not-md">lab_flask</i>' + '<i class="icon material-icons md-only">science</i>' + '</div>' + '<div class="universal-result-body"><div class="universal-result-title">' + esc(t.name) + '</div><div class="universal-result-sub">' + sub + '</div></div>' + price + '<i class="icon f7-icons if-not-md universal-result-arrow">chevron_right</i>' + '<i class="icon material-icons md-only universal-result-arrow">chevron_right</i>' + '</a>';
      }
      function renderResults(payload) {
        var doctors = payload && payload.doctors || [];
        var departments = payload && payload.departments || [];
        var hospitals = payload && payload.hospitals || [];
        var tests = payload && payload.tests || [];
        var total = doctors.length + departments.length + hospitals.length + tests.length;
        if (total === 0) {
          $$('#universalResults').hide();
          $$('#searchInitialState').hide();
          $$('#searchNoResults').show();
          return;
        }
        $$('#searchInitialState').hide();
        $$('#searchNoResults').hide();
        $$('#universalResults').show();
        if (doctors.length) {
          var html = '';
          doctors.forEach(function (d) {
            html += renderDoctorRow(d);
          });
          $$('#grpDoctorsBody').html(html);
          $$('#grpDoctors').show();
        } else {
          $$('#grpDoctors').hide();
        }
        if (departments.length) {
          var html2 = '';
          departments.forEach(function (d) {
            html2 += renderDepartmentRow(d);
          });
          $$('#grpDepartmentsBody').html(html2);
          $$('#grpDepartments').show();
        } else {
          $$('#grpDepartments').hide();
        }
        if (hospitals.length) {
          var html3 = '';
          hospitals.forEach(function (h) {
            html3 += renderHospitalRow(h);
          });
          $$('#grpHospitalsBody').html(html3);
          $$('#grpHospitals').show();
        } else {
          $$('#grpHospitals').hide();
        }
        if (tests.length) {
          var html4 = '';
          tests.forEach(function (t) {
            html4 += renderTestRow(t);
          });
          $$('#grpTestsBody').html(html4);
          $$('#grpTests').show();
        } else {
          $$('#grpTests').hide();
        }
      }
      function performSearch(q) {
        if (!q || q.length < 2) {
          showInitial();
          return;
        }
        if (currentReq && currentReq.abort) {
          try {
            currentReq.abort();
          } catch (e) {
          }
        }
        var city = localStorage.getItem('city') || '';
        var url = app.data.remoteUrl + 'search?q=' + encodeURIComponent(q) + '&city=' + encodeURIComponent(city) + '&limit=10';
        currentReq = app.request({
          url: url,
          method: 'GET',
          dataType: 'json',
          success: function (response) {
            currentReq = null;
            var data = response && response.data ? response.data : response;
            renderResults(data || {});
          },
          error: function () {
            currentReq = null;
          }
        });
      }
      $$('#universalSearchInput').on('input', function () {
        var q = $$(this).val().trim();
        if (searchTimeout)
          clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
          performSearch(q);
        }, 350);
      });
      $$('#universalClearBtn').on('click', function () {
        $$('#universalSearchInput').val('');
        showInitial();
      });
      $$('#universalSearchForm').on('submit', function (ev) {
        ev.preventDefault();
        performSearch($$('#universalSearchInput').val().trim());
      });
    }
  },
  id: '14bd01214a',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="search" id="universalSearchPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">Search</div>\n            </div>\n        </div>\n\n        <div class="page-content">\n            <div class="doctor-list-search-wrap">\n                <form class="searchbar searchbar-inline" id="universalSearchForm">\n                    <div class="searchbar-inner">\n                        <div class="searchbar-input-wrap">\n                            <i class="icon f7-icons if-not-md mdoc-sb-icon">search</i>\n                            <i class="icon material-icons md-only mdoc-sb-icon">search</i>\n                            <input type="search" id="universalSearchInput" placeholder="Search doctors, specialities, hospitals, tests\u2026" autofocus>\n                            <span class="input-clear-button" id="universalClearBtn"></span>\n                        </div>\n                    </div>\n                </form>\n            </div>\n\n            <!-- Initial prompt -->\n            <div class="empty-state" id="searchInitialState">\n                <i class="icon f7-icons if-not-md" style="font-size: 56px; color: var(--mdoc-border);">search</i>\n                <i class="icon material-icons md-only" style="font-size: 56px; color: var(--mdoc-border);">search</i>\n                <div class="empty-state-title" style="margin-top:14px;">What are you looking for?</div>\n                <div class="empty-state-sub">Type at least 2 characters to search across doctors, specialities, hospitals, and lab tests.</div>\n            </div>\n\n            <!-- Results -->\n            <div id="universalResults" style="display:none;">\n                <!-- Doctors -->\n                <div class="search-group" id="grpDoctors" style="display:none;">\n                    <div class="hspt-heading"><span>Doctors</span></div>\n                    <div class="doctor-list" id="grpDoctorsBody"></div>\n                </div>\n\n                <!-- Specialities -->\n                <div class="search-group" id="grpDepartments" style="display:none;">\n                    <div class="hspt-heading"><span>Specialities</span></div>\n                    <div class="universal-result-list" id="grpDepartmentsBody"></div>\n                </div>\n\n                <!-- Hospitals -->\n                <div class="search-group" id="grpHospitals" style="display:none;">\n                    <div class="hspt-heading"><span>Hospitals</span></div>\n                    <div class="universal-result-list" id="grpHospitalsBody"></div>\n                </div>\n\n                <!-- Lab Tests -->\n                <div class="search-group" id="grpTests" style="display:none;">\n                    <div class="hspt-heading"><span>Lab Tests</span></div>\n                    <div class="universal-result-list" id="grpTestsBody"></div>\n                </div>\n            </div>\n\n            <!-- No results -->\n            <div class="empty-state" id="searchNoResults" style="display:none;">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">Nothing matched your search</div>\n                <div class="empty-state-sub">Try a different keyword or check spelling.</div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};